import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAnalytics, logEvent } from "firebase/analytics";

// Relative time.
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

// Redux.
import { connect } from 'react-redux';

// Components.
import LibraryHeader from './LibraryHeader';
import BottomMenu from './BottomMenu';
import LibraryFollowing from './LibraryFollowing';


const LibraryContent = ({
    // Redux.
    authenticated,
    uid,
}) => {
    const analytics = getAnalytics();

    const navigate = useNavigate();

    useEffect(() => {
        dayjs.extend(relativeTime);
        logEvent(analytics, 'screen_view', {
            firebase_screen: 'library'
        });
        if (!authenticated) {
            navigate('/');
        }
    }, []);

    return (
        <div className='container hideScrollbar appScreen'>
            <div>
                <div className='hasBottomMenu'>
                    <LibraryHeader />
                    <LibraryFollowing key={uid} />
                    <BottomMenu />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
    uid: state.user.uid,
})

const mapActionsToProps = {
}

export default connect(mapStateToProps, mapActionsToProps)(LibraryContent);
